// extracted by mini-css-extract-plugin
export var container = "index-module--container--1i6m7";
export var shareBlock = "index-module--shareBlock--1A1LU";
export var share = "index-module--share--U9_ii";
export var inner = "index-module--inner--2mjkl";
export var shareNotification = "index-module--shareNotification--3zrcl";
export var show = "index-module--show--a22kt";
export var hide = "index-module--hide--25vqi";